var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" CompetitionFilterUserFilter "),_c('button',{on:{"click":_vm.openFilter}},[_vm._v(_vm._s(_vm.$t('filter')))]),_c('competition-filter-user-filter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }